import { render, staticRenderFns } from "./sponsorebene.vue?vue&type=template&id=221a39c0&scoped=true&"
import script from "./sponsorebene.vue?vue&type=script&lang=js&"
export * from "./sponsorebene.vue?vue&type=script&lang=js&"
import style0 from "./sponsorebene.vue?vue&type=style&index=0&id=221a39c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a39c0",
  null
  
)

export default component.exports